export default {
    general: {
        changeClosureCount: 'CHANGE_CLOSURE_COUNT',
        changeSaleNotesCount: 'CHANGE_SALE_NOTES_COUNT',
        changeBillingCount: 'CHANGE_BILLING_COUNT',
        changeUserData: 'CHANGE_USER_DATA'
    }
};
